<template>
  <div class="container">
    <!-- loader -->
    <div class="loader" v-if="loading === true">
      <div v-loading="true"></div>
    </div>

    <!-- post -->
    <div v-else>
      <el-button
        class="closeButton"
        type="primary"
        icon="Close"
        circle
        @click="volver"
      >
      </el-button>

      <div class="card">
        <el-card>
          <div class="card_content">
            <el-row
              ><el-col class="title">{{ entradaForo.Titulo }}</el-col></el-row
            >
            <el-row
              ><el-col class="body">{{
                entradaForo.Descripcion
              }}</el-col></el-row
            >
            <el-row>
              <el-col class="images">
                <el-carousel indicator-position="outside" height="467px" :interval="10000">
                  <el-carousel-item
                    v-for="(imagen, index) in entradaForo.Imagenes"
                    :key="index"
                  >
                    <img class="img" :src="imagen" />
                  </el-carousel-item>
                </el-carousel>
              </el-col>
            </el-row>
          </div>
        </el-card>
        <el-row>
          <el-col class="container_btn-responder">
            <span class="nro_mjs" @click="toggleShowComentarios">
              <el-icon class="icon"><ChatLineSquare /></el-icon>{{ entradaForo.Comentarios.length }}
            </span>
          </el-col>
        </el-row>
      </div>

      <div class="divider"></div>

      <div class="comentarios" v-if="showComentarios">
        <Comentario
          v-for="comentario in entradaForo.Comentarios"
          :permitirImagenes="entradaForo.PermitirImagenes"
          :comentario="comentario"
          :idForo="entradaForo.Id"
          :key="comentario.Id"
          :depth="0"
        />
      </div>

      <div class="leave_comment">
        <Respuesta
          :idForo="entradaForo.Id"
          :afterSave="afterSaveRespuesta"
          :permitirImagenes="entradaForo.PermitirImagenes"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Comentario from "@/components/Foro/comentario";
import Respuesta from "@/components/Foro/respuesta";
import { showError } from "../Mensaje";

export default {
  name: "EntradaForo",
  components: { Comentario, Respuesta },
  data() {
    return {
      showComentarios: true,
      entradaForo: undefined,
      loading: true,
    };
  },
  methods: {
    buscar(id) {
      this.$store
        .dispatch("foro/getEntradaForo", id)
        .then((data) => {
          if (!data) showError(this.$t("FORO_missing"));

          this.entradaForo = data;
        })
        .finally(() => (this.loading = false));
    },

    toggleShowComentarios() {
      this.showComentarios = !this.showComentarios;
    },

    afterSaveRespuesta(newRespuesta) {
      this.entradaForo.Comentarios.push(newRespuesta);
    },

    volver() {
      this.$router.push({ name: "Foro" });
    },
  },
  mounted() {
    let id = this.$route.params.id;
    this.buscar(id);
  },
};
</script>

<style scoped>
.card {
  width: 80%;
  margin: 0 auto;
}
.card_content {
  padding: 10px;
}
.title {
  font-weight: bold;
  font-size: 20px;
  line-height: 28px;
  color: var(--main-color);
  text-align: left;
  margin-bottom: 10px;
}
.body {
  font-size: 14px;
  line-height: 18px;
  color: #5a5a5a;
  text-align: left;
}
.images {
  max-height: 485px;
  margin-top: 20px;
}
.img {
  max-width: 900px;
  height: 465px;
  max-height: 465px;
  margin: 0 50px;
}

.divider {
  border-bottom: 1px dotted #c4c4c4;
  display: inline-block;
  width: 80%;
}

.nro_mjs {
  color: #6f6f6f;
  font-size: 14px;
  top: 5px;
  cursor: pointer;
  text-align: right;
}
.icon {
  margin-right: 10px;
}
.comentarios {
  margin: 20px auto;
  width: 95%;
}
.comentario {
  padding: 10px 0;
}
.container_btn-responder {
  margin-top: 20px;
  text-align: right;
}
.btn-responder {
  color: rgb(90, 90, 90);
  cursor: pointer;
}
.btn-responder:hover {
  color: var(--main-color);
}
.leave_comment {
  margin: 20px auto;
  width: 95%;
}

.loader {
  margin-top: 20px;
  height: 50px;
}

.closeButton {
  position: fixed;
  right: 20px;
  height: 50px;
  width: 50px;
}
</style>

<style>
.el-carousel__indicators--outside button {
    background-color: #2057c6;
    opacity: .40;
}
</style>
